// Import model
import { PageMenuItem } from '../models/PageMenuItem';

// Import base class serializer
import { MenuItemSerializer } from './MenuItemSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PageMenuItem - handles JSON serialization and deserialization with type validation
 */
export class PageMenuItemSerializer {
  /**
   * Deserializes a JSON string into a PageMenuItem instance
   */
  static deserialize(json: string): PageMenuItem {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PageMenuItem instance
   */
  static fromObject(obj: any): PageMenuItem {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PageMenuItem');
    }


    const instance: PageMenuItem = {
      icon: obj['Icon'] as string | undefined,
      t: obj['_t'] as string,
      name: obj['Name'] as string,
      label: obj['Label'] as string | undefined,
      enable: obj['Enable'] ? (obj['Enable'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      visible: obj['Visible'] ? (obj['Visible'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      page: obj['Page'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PageMenuItem instances
   */
  static deserializeArray(json: string): PageMenuItem[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PageMenuItem instance to a JSON string
   */
  static serialize(instance: PageMenuItem): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PageMenuItem instance to a plain object
   */
  static toObject(instance: PageMenuItem): any {
    return {
      'Icon': instance.icon,
      '_t': instance.t,
      'Name': instance.name,
      'Label': instance.label,
      'Enable': instance.enable?.map((item: any) =>
        item
      ),
      'Visible': instance.visible?.map((item: any) =>
        item
      ),
      'Page': instance.page,
    };
  }

  /**
   * Serializes an array of PageMenuItem instances to a JSON string
   */
  static serializeArray(instances: PageMenuItem[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
